import React from "react";

function AboutPage() {
    return (
        <div className="container">
            <div className="hero-block">
                <h1 className="hero-heading">About Me</h1>
                <div className="text-lead">👋 Hi There</div>
                <div className="content-block">
                    <div>
                        I &#x27;m a graduate <strong>Civil Engineer</strong> 👷🏿 from the <strong>University of the Witwatersrand 📚</strong>, South Africa. I
                        started my program in 2016. In 1st year I started to learn coding during my Introduction to
                        Programming course module using <strong>VBA</strong>. 2017, I started to learn <strong>mobile app development</strong> using
                        Java. 2018, I published my first app called Yonke, a salon-booking app. It was selected as the <strong>Top 10 finalist Seedstar</strong> (Johannesburg).
                        <br/>
                        <br/>
                        2019, I expanded my interest to <strong>web development</strong> using <strong>React JS</strong>. Mobile and Web
                        development has enabled me to work as a freelancer developing, designing and publish applications. During my final year
                        I developed a web app that can detect cracks on concrete surfaces using a Convolutional Neural Networks model trained by me.
                        The project was awarded the Best Final Year Project and the paper was presented on the 6th
                        <strong>International Conference on Concrete Repair, Rehabilitation and Retrofitting</strong> (ICCRRR) in Cape Town, 2022.

                    </div>
                </div>
            </div>
            {/*<div className="container-small">*/}
            {/*</div>*/}
            {/*<div className="block-divider"></div>*/}
            {/*<div className="section-block">*/}
            {/*    <div className="content-title-wrap">*/}
            {/*        <div className="content-title-dot"></div>*/}
            {/*        <h2 className="content-title">FAQ</h2>*/}
            {/*    </div>*/}
            {/*    <div id="w-node-ddd9201c-4902-fec8-05c5-e75fa2214fa3-ec061186" className="accordion-list">*/}
            {/*        <div data-click="faq" className="accordion">*/}
            {/*            <div className="accordion-top">*/}
            {/*                <div className="accordion-top-wrap">*/}
            {/*                    <div>Do you offer web development service?</div>*/}
            {/*                </div>*/}
            {/*                <div className="accordion-top-icon">*/}
            {/*                    <div className="accordion-top-icon-wrap">*/}
            {/*                        <div className="accordion-icon-stripe-2"></div>*/}
            {/*                        <div className="accordion-icon-stripe-1"></div>*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*            </div>*/}
            {/*            <div className="accordion-bottom">*/}
            {/*                <div className="accordion-bottom-wrap">*/}
            {/*                    <div>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius*/}
            {/*                        enim in eros elementum tristique. Duis cursus, mi quis viverra ornare, eros*/}
            {/*                        dolor interdum nulla, ut commodo diam libero vitae erat. Aenean faucibus*/}
            {/*                        nibh et justo cursus id rutrum lorem imperdiet. Nunc ut sem vitae risus*/}
            {/*                        tristique posuere.*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*            </div>*/}
            {/*        </div>*/}
            {/*        <div data-click="faq" className="accordion">*/}
            {/*            <div className="accordion-top">*/}
            {/*                <div className="accordion-top-wrap">*/}
            {/*                    <div>Do you do branding or art direction?</div>*/}
            {/*                </div>*/}
            {/*                <div className="accordion-top-icon">*/}
            {/*                    <div className="accordion-top-icon-wrap">*/}
            {/*                        <div className="accordion-icon-stripe-2"></div>*/}
            {/*                        <div className="accordion-icon-stripe-1"></div>*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*            </div>*/}
            {/*            <div className="accordion-bottom">*/}
            {/*                <div className="accordion-bottom-wrap">*/}
            {/*                    <div>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius*/}
            {/*                        enim in eros elementum tristique. Duis cursus, mi quis viverra ornare, eros*/}
            {/*                        dolor interdum nulla, ut commodo diam libero vitae erat. Aenean faucibus*/}
            {/*                        nibh et justo cursus id rutrum lorem imperdiet. Nunc ut sem vitae risus*/}
            {/*                        tristique posuere.*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*            </div>*/}
            {/*        </div>*/}
            {/*        <div data-click="faq" className="accordion">*/}
            {/*            <div className="accordion-top">*/}
            {/*                <div className="accordion-top-wrap">*/}
            {/*                    <div>How can I contact you?</div>*/}
            {/*                </div>*/}
            {/*                <div className="accordion-top-icon">*/}
            {/*                    <div className="accordion-top-icon-wrap">*/}
            {/*                        <div className="accordion-icon-stripe-2"></div>*/}
            {/*                        <div className="accordion-icon-stripe-1"></div>*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*            </div>*/}
            {/*            <div className="accordion-bottom">*/}
            {/*                <div className="accordion-bottom-wrap">*/}
            {/*                    <div>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius*/}
            {/*                        enim in eros elementum tristique. Duis cursus, mi quis viverra ornare, eros*/}
            {/*                        dolor interdum nulla, ut commodo diam libero vitae erat. Aenean faucibus*/}
            {/*                        nibh et justo cursus id rutrum lorem imperdiet. Nunc ut sem vitae risus*/}
            {/*                        tristique posuere.*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*            </div>*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*</div>*/}
            {/*<div className="block-divider"></div>*/}
            {/*<div className="section-block">*/}
            {/*    <div className="w-layout-grid content-grid">*/}
            {/*        <div className="content-title-wrap">*/}
            {/*            <div className="content-title-dot"></div>*/}
            {/*            <h2 className="content-title">Clients’ reviews</h2>*/}
            {/*        </div>*/}
            {/*        <div id="w-node-_0b816a0d-4b20-6cdc-5311-d7b39af90303-ec061186" className="content-list">*/}
            {/*            <div className="testimonial-card">*/}
            {/*                <div className="testimonial-quote">*/}
            {/*                    <div className="testimonial-quotation-mark">“</div>*/}
            {/*                    <div>We had a lot of fun working with Brandon. He has impressive web development*/}
            {/*                        skills and expertise in the latest technologies.”*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*                <div className="testimonial-footer">*/}
            {/*                    <div>Alan, Designer Only</div>*/}
            {/*                </div>*/}
            {/*            </div>*/}
            {/*            <div className="testimonial-card">*/}
            {/*                <div className="testimonial-quote">*/}
            {/*                    <div className="testimonial-quotation-mark">“</div>*/}
            {/*                    <div>*/}
            {/*                        Brandon is a talented web developer. Honest and genuine service.*/}
            {/*                        Brandon &#x27;s enthusiasm is contagious.”<br/>*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*                <div className="testimonial-footer">*/}
            {/*                    <div>Selena, Account Director PetDesk</div>*/}
            {/*                </div>*/}
            {/*            </div>*/}
            {/*            <div className="testimonial-card">*/}
            {/*                <div className="testimonial-quote">*/}
            {/*                    <div className="testimonial-quotation-mark">“</div>*/}
            {/*                    <div>We have been collaborating for years and it is a pleasure every day!*/}
            {/*                        Launching a website in four weeks was already quite a challenge... And you*/}
            {/*                        did it in three!”*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*                <div className="testimonial-footer">*/}
            {/*                    <div>Thomas, Co-Fonder Arial</div>*/}
            {/*                </div>*/}
            {/*            </div>*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*</div>*/}
            {/*<div className="block-divider"></div>*/}
            {/*<div className="section-block">*/}
            {/*    <div className="w-layout-grid content-grid">*/}
            {/*        <div className="content-title-wrap">*/}
            {/*            <div className="content-title-dot"></div>*/}
            {/*            <h2 className="content-title">Pricing</h2>*/}
            {/*        </div>*/}
            {/*        <div id="w-node-_092c14f9-f4ab-5818-6798-ab8a01b2f68a-ec061186">*/}
            {/*            <div className="pricing-heading">120€/h</div>*/}
            {/*            <div>*/}
            {/*                The completion time of a Web project is evaluated at the beginning of the mandate*/}
            {/*                and everything is put in place to respect it.<br/>*/}
            {/*                <br/>*/}
            {/*                Web hosting is afford uneasy joy she thrown though bed set. In me forming general*/}
            {/*                prudent on country carried to monthly maintenance ranging from €120 to €200.<br/>*/}
            {/*                <br/>It prepare is ye nothing blushes up brought. Or as gravity pasture limited*/}
            {/*                evening on.*/}
            {/*            </div>*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*</div>*/}
            {/*<div className="block-divider"></div>*/}
            {/*<div className="section-block">*/}
            {/*    <div className="w-layout-grid content-grid">*/}
            {/*        <div className="content-title-wrap">*/}
            {/*            <div className="content-title-dot"></div>*/}
            {/*            <h2 className="content-title">*/}
            {/*                Friends<br/>*/}
            {/*            </h2>*/}
            {/*        </div>*/}
            {/*        <div id="w-node-_73a56efd-c6de-501e-0961-f2649075254a-ec061186">*/}
            {/*            <a href="#" className="friends-link w-inline-block">*/}
            {/*                <div>Tom Huang, Creative Director</div>*/}
            {/*                <div className="icon-svg w-embed">*/}
            {/*                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">*/}
            {/*                        <path fill-rule="evenodd"*/}
            {/*                              d="M5.22 14.78a.75.75 0 001.06 0l7.22-7.22v5.69a.75.75 0 001.5 0v-7.5a.75.75 0 00-.75-.75h-7.5a.75.75 0 000 1.5h5.69l-7.22 7.22a.75.75 0 000 1.06z"*/}
            {/*                              clip-rule="evenodd"/>*/}
            {/*                    </svg>*/}
            {/*                </div>*/}
            {/*                <div className="link-underline"></div>*/}
            {/*            </a>*/}
            {/*            <a href="#" className="friends-link w-inline-block">*/}
            {/*                <div>Kelly Kraft, Account Manger</div>*/}
            {/*                <div className="icon-svg w-embed">*/}
            {/*                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">*/}
            {/*                        <path fill-rule="evenodd"*/}
            {/*                              d="M5.22 14.78a.75.75 0 001.06 0l7.22-7.22v5.69a.75.75 0 001.5 0v-7.5a.75.75 0 00-.75-.75h-7.5a.75.75 0 000 1.5h5.69l-7.22 7.22a.75.75 0 000 1.06z"*/}
            {/*                              clip-rule="evenodd"/>*/}
            {/*                    </svg>*/}
            {/*                </div>*/}
            {/*                <div className="link-underline"></div>*/}
            {/*            </a>*/}
            {/*            <a href="#" className="friends-link w-inline-block">*/}
            {/*                <div>Frank Lewis, Strategy &amp;Content</div>*/}
            {/*                <div className="icon-svg w-embed">*/}
            {/*                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">*/}
            {/*                        <path fill-rule="evenodd"*/}
            {/*                              d="M5.22 14.78a.75.75 0 001.06 0l7.22-7.22v5.69a.75.75 0 001.5 0v-7.5a.75.75 0 00-.75-.75h-7.5a.75.75 0 000 1.5h5.69l-7.22 7.22a.75.75 0 000 1.06z"*/}
            {/*                              clip-rule="evenodd"/>*/}
            {/*                    </svg>*/}
            {/*                </div>*/}
            {/*                <div className="link-underline"></div>*/}
            {/*            </a>*/}
            {/*            <a href="#" className="friends-link w-inline-block">*/}
            {/*                <div>Maria Kelly, Illustration</div>*/}
            {/*                <div className="icon-svg w-embed">*/}
            {/*                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">*/}
            {/*                        <path fill-rule="evenodd"*/}
            {/*                              d="M5.22 14.78a.75.75 0 001.06 0l7.22-7.22v5.69a.75.75 0 001.5 0v-7.5a.75.75 0 00-.75-.75h-7.5a.75.75 0 000 1.5h5.69l-7.22 7.22a.75.75 0 000 1.06z"*/}
            {/*                              clip-rule="evenodd"/>*/}
            {/*                    </svg>*/}
            {/*                </div>*/}
            {/*                <div className="link-underline"></div>*/}
            {/*            </a>*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*</div>*/}
        </div>
    )
}

export default AboutPage